// extracted by mini-css-extract-plugin
export default {"navigateButton":"NavigateButton_navigateButton__KztRc"};